import { Injectable, signal } from '@angular/core';
import { User } from '@angular/fire/auth';
import { UserPayload } from '../models/user.model';
import { removeEmptyAttributes } from '../utilities';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  currentUserSig = signal<UserPayload | null | undefined>(undefined);
  token = signal<string | null>(null);

  setToken(token: string | null) {
    this.token.set(token);
  }

  getToken() {
    return this.token();
  }

  getUserPayload(user: User): UserPayload {
    const userPayload: UserPayload = {
      userId: user.uid,
      emailVerified: user.emailVerified,
      email: user.email,
      contactNumber: user.phoneNumber,
      avatarURL: user.photoURL,
      displayName: user.displayName,
    };

    return removeEmptyAttributes(userPayload);
  }
}
